import { withErrorBoundary } from '@sentry/react'
import { Tooltip } from 'antd'
import { Fragment, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'

import PlaybookIconGrey from 'src/assets/Playbooks.svg'
import PlaybookIconRed from 'src/assets/Playbooks_Selected.svg'
import IncidentIconGrey from 'src/assets/incidents.svg'
import IncidentIconRed from 'src/assets/incidents_selected.svg'
import MonitorIconGrey from 'src/assets/monitor.svg'
import MonitorIconRed from 'src/assets/monitor_selected.svg'
import ReportIconGrey from 'src/assets/reports.svg'
import ReportIconRed from 'src/assets/reports_selected.svg'
import OnMountTransition from 'src/components/common/OnMountTransition'
import SimulationCtx from 'src/context/simulationCtx'
import routes from 'src/routes'

import SentryFallback from '../SentryFallback'

const Sidebar = () => {
    const { isEnabled: isSimulationEnabled } = useContext(SimulationCtx)

    return (
        <Fragment>
            <OnMountTransition>
                <div
                    id="sidebar-main"
                    className="fixed left-0 right-0 top-[40px] z-20 h-[calc(100vh-37px)] w-[15vw] overflow-y-auto md:w-[5vw]"
                    style={{
                        background: '#2F3B52',
                    }}
                >
                    <div
                        className={`${isSimulationEnabled ? 'mt-16' : 'mt-10'}`}
                    >
                        <div className="mt-9 w-full">
                            <Section
                                sectionLabel="Plan"
                                routeName="plan"
                                imageGrey={PlaybookIconGrey}
                                imageRed={PlaybookIconRed}
                            />
                            <Section
                                sectionLabel="Practice"
                                routeName="practice"
                                imageGrey={ReportIconGrey}
                                imageRed={ReportIconRed}
                            />
                            <Section
                                sectionLabel="Respond"
                                routeName="respond"
                                imageGrey={IncidentIconGrey}
                                imageRed={IncidentIconRed}
                            />
                            <Section
                                sectionLabel="Monitor"
                                routeName="monitor"
                                imageGrey={MonitorIconGrey}
                                imageRed={MonitorIconRed}
                            />
                        </div>
                    </div>
                </div>
            </OnMountTransition>
        </Fragment>
    )
}

const Section = ({ sectionLabel, routeName, imageGrey, imageRed }) => {
    const location = useLocation()

    return (
        <Tooltip placement="right" title={<p>{sectionLabel}</p>}>
            <Link to={routes[routeName]}>
                <div className="flex w-full items-center justify-center py-2 lg:py-4">
                    <div
                        className={
                            location.pathname.includes(routes[routeName])
                                ? 'w-full cursor-pointer bg-neutral-gray-500 px-2 py-4'
                                : 'w-full cursor-pointer px-2 py-4'
                        }
                    >
                        <img
                            src={
                                location.pathname.includes(routes[routeName])
                                    ? imageRed
                                    : imageGrey
                            }
                            alt=""
                            width="25"
                            height="25"
                            className="mx-auto"
                            style={{ minHeight: '25px', minWidth: '25px' }}
                        />
                    </div>
                </div>
            </Link>
        </Tooltip>
    )
}

export default withErrorBoundary(Sidebar, {
    fallback: <SentryFallback />,
})
